module.exports = __webpack_public_path__ + "static/carlsbad-10-62e70e89d7b6d3f2ef35b2f4efe8475e.png";